export enum OptionTypes {
    ALL = "ALL",
    SERVICE = "SERVICE",
    DOCTOR = "DOCTOR",
}
